import { render } from "./ResourceView.vue?vue&type=template&id=e00226c6&scoped=true"
import script from "./ResourceView.vue?vue&type=script&lang=js"
export * from "./ResourceView.vue?vue&type=script&lang=js"

import "./ResourceView.vue?vue&type=style&index=0&id=e00226c6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e00226c6"]])

export default __exports__